import {
    axiosRebuildMyImagesJSON,
    axiosDeleteImage,
    axiosSaveImage,
} from '../../api/admin/common';

window.displayLimitImage = 51;
window.myImageListProcess = '';
window.cacheImageMore;
window.cacheFreeImageMore;
window.cacheFreeImageBGMore;
window.processListFreeImage = false;
window.processListFreeBackground = false;
window.isSectionBG = false;
window.isTexture = false;
window.isSiteBG = false;
window.isBlockBG = false;
window.isFooterBG = false;

(function ($) {
    var focusImage;
    var xhrImageUL = {};
    var indexXHR = [];
    var removeItem = [];
    var sumFiles = 0;
    var noticeUL = null;
    var IdBarNew = {};
    var IsBackground = false;
    var isBlockBackground = false;

    RVwys.imageUL = {};
    var linkULERR =
        '<a href="javascript:void(0)" onclick= RVwys.imageUL.open()> click </a>';
    const CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

    console.log('parent.storeimages: ', parent.storeimages);
    console.log('parent.aFreeImages: ', parent.aFreeImages);

    RVwys.imageUL.bgOpen = function () {
        IsBackground = true;
        isBlockBackground = false;

        $('.wys-imageUpload').show();
        if (noticeUL) {
            noticeUL.remove();
            noticeUL = null;
        }
    };

    RVwys.imageUL.blockOpen = function () {
        IsBackground = true;
        isBlockBackground = true;

        $('.wys-imageUpload').show();
        if (noticeUL) {
            noticeUL.remove();
            noticeUL = null;
        }
    };

    RVwys.imageUL.open = function () {
        IsBackground = false;
        isBlockBackground = false;

        $('.wys-imageUpload').show();
        if (noticeUL) {
            noticeUL.remove();
            noticeUL = null;
        }
    };

    RVwys.imageUL.clearNoticeComAll = function (id) {
        sumFiles = sumFiles - indexXHR.length;
        //alert(removeItem)
        //console.log(indexXHR)
        console.log('removeItem' + removeItem);
        indexXHR = indexXHR.filter(function (el) {
            return removeItem.indexOf(el) < 0;
        });
    };
    RVwys.imageUL.clearNoticeUL = function (id) {
        //alert(indexXHR[this.id])
        //key = indexXHR.indexOf(this.id)
        // indexXHR.splice(key,1);
        removeItem.push(id);
    };

    RVwys.imageUL.success = function (data) {
        $('#' + data.id).attr('src', data.thumb);
        IdBarNew[data.id].set(100);
        Object.assign(parent.myimages, data.myimages);
        Object.assign(parent.storeimages, data.storeimages);
        var d = new Date();
        var n = d.getTime();
        parent.$('.myImageJSON').each(function () {
            var src = $(this)
                .attr('src')
                .replace(/\?n=\w*/gim, '');

            $(this).attr('src', src + '?n=' + n);
        });
        var imageItemHTML = parent.$('#designMyImageItem').html();
        var oImageItem = $(imageItemHTML);
        oImageItem.find('.insert').attr({ data: data.url, imagekey: data.id });
        oImageItem
            .find('.remove')
            .attr({ imagename: data.name, imagekey: data.id });
        var attr = { src: data.thumb, id: 'view_' + data.id };
        oImageItem.find('.imageItems').attr(attr);
        if (parent.$('.imageBoxView-myimage').find('.workspace').html() != '') {
            oImageItem = RVwys.imagemanager.eventMyImage(oImageItem);
            parent
                .$('.imageBoxView-myimage')
                .find('.workspace')
                .prepend(oImageItem);
            parent.RVwys.imagemanager.initImageDrag(oImageItem);
        }
        if (IsBackground) {
            var sectionActive = $('.mgActive').get(0)
                ? $('.mgActive')
                : $('#frameBody').get(0).contentWindow.$('.mgActive');

            if (isBlockBackground) {
                sectionActive = parent.RVwys.getBlockBG;
            }

            var isCssRGBA = sectionActive.css('background-color');
            var validateRGB = {
                'rgb(': true,
                'rgba(0,0,0,0)': true,
            };
            if (isCssRGBA == '') {
                var repairRGBA = 'rgba(255,255,255,.2)';
            }
            repairRGBA = isCssRGBA.replace(/rgb\((.*?)\)/gim, 'rgba($1,.2)');
            sectionActive.css('background-color', repairRGBA);
            var cssSectionActive = sectionActive.parent();
            if (isBlockBackground) {
                cssSectionActive = sectionActive;
            }
            cssSectionActive.css({
                'background-image': 'url(' + data.url + ')',
                'background-repeat': 'no-repeat',
                'background-size': 'cover',
                'background-attachment': 'fixed',
            });

            var thumbnailPanel = parent.$('.wys-rowFour').find('.section-bg');
            if (isBlockBackground) {
                thumbnailPanel = parent.$('.wys-rowThree').find('.block-bg');
            }

            thumbnailPanel.css({
                background: 'url(' + data.url + ') no-repeat 50% / contain',
            });

            if (parent.rowParallaxSlide) {
                var imgSlide = $(
                    '[data-banner=' + parent.currentSlide + ']'
                ).get(0)
                    ? $('[data-banner=' + parent.currentSlide + ']')
                    : $('#frameBody')
                          .get(0)
                          .contentWindow.$(
                              '[data-banner=' + parent.currentSlide + ']'
                          );

                //				tag Img
                imgSlide.find('img').attr('src', data.url);

                //				uk-Slide- background
                imgSlide.children('.uk-cover-background').css({
                    'background-image': 'url(' + data.url + ')',
                });
            }

            $('.wys-imageUpload').hide();
        }
        setTimeout(function () {
            //alert(data.id)
            $('#UL' + data.id).remove();
            delete IdBarNew[data.id];
            delete xhrImageUL[data.id];

            $('#' + data.id)
                .parent()
                .find('.remove-image-upload')
                .remove();
        }, 500);
    };

    RVwys.imageUL.error = function (data) {
        var msg = data.message;

        console.pop.error({ title: 'Error ' + data.code, text: msg });
    };

    RVwys.showNotifyUL = function () {
        noticeUL = new PNotify({
            text: 'Please Wait',
            type: 'info',
            icon: 'fa fa-spinner fa-spin',
            hide: false,
            buttons: {
                closer: false,
                sticker: false,
            },
            shadow: false,
            width: '170px',
        });
    };

    $(document).bind('editorReady', function () {
        $('#refreshMyImages').click(function () {
            axiosRebuildMyImagesJSON()
                .then(result => {
                    parent.myimages = result.data.myimages;
                    parent.storeimages = result.data.storeimages;
                    parent.$('.imageBoxView-myimage .workspace').html('');
                    RVwys.loadMyImages();
                })
                .catch(err => {
                    console.log('err: ', err);
                });
        });

        //mini_insertImageInline
        $('.clearViewUL').click(function () {
            $('#upload-contener').html('');
        });
        $('.hideProcess').click(function () {
            $('.wys-imageUpload').hide();
            //dyn_notice();

            if (sumFiles > 0) {
                console.log('noticeUL' + noticeUL);
                if (!noticeUL) {
                    RVwys.showNotifyUL();
                }
            }
        });
        $('.uiImageUpload').click(function () {
            RVwys.imageUL.open();
        });
        var settings = {
            action: parent.wex.route_action.routeCommonUploadImage,
            IdBar: null,
            type: 'json',
            params: {
                _token: $('meta[name="csrf-token"]').attr('content'),
            },
            allow: '*.(jpg|jpeg|gif|png)',
            beforeAll: function (files) {
                sumFiles += files.length;
            },
            before: function (setting, files) {
                //alert(files.length)
                if (this.filelimit) {
                    delete this.filelimit;
                }
                if (IsBackground) {
                    this.filelimit = 1;
                    sumFiles = 1;
                }
                var nowId = $.now();
                this.params['id'] = 'imgUL' + nowId;
                this.id = this.params['id'];
                indexXHR.push(this.params['id']);
                xhrImageUL = {};
            },
            beforeSend: function (xhr) {
                xhrImageUL[this.params['id']] = xhr;
                var id = this.params['id'];
            },
            bytesToSize: function (bytes) {
                var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                if (bytes == 0) return '0 Byte';
                var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                return (
                    Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
                );
            },
            loadstart: function (e) {
                var idS = this.params['id'];
                var item = $('.ui-image-container')
                    .html()
                    .replace('#id#', 'id = "' + idS + '"');
                item = item.replace(/\#attrid\#/gim, idS);
                //item = item.replace('#src#','src = "http://192.168.100.82/rvwysiwyguikit/theme/default/images/loading-rec.gif"')

                $.when($('#upload-contener').append($(item))).then(function (
                    elm
                ) {
                    //alert('s')
                    //alert($('#UL'+idS).get(0))
                    console.log('loadbar->' + idS);
                    IdBarNew[idS] = new ldBar($('#UL' + idS).get(0), {
                        stroke: '#FFF',
                    });
                    elm.find('.remove-image-upload').click(function () {
                        var id = $(this).attr('cmd');

                        if (xhrImageUL[id] != undefined) {
                            xhrImageUL[id].abort();
                        }
                        $(this).closest('.view-image-container').remove();
                    });
                });
            },

            progress: function (percent) {
                percent = Math.ceil(percent);
                //var id = this.params['id'];
                var id = this.id;
                console.log('progress' + id);
                //$('#TFB'+id).html(percent);
                //alert(IdBarNew[id])
                if (percent == 100) {
                    percent = 99;
                }
                console.log('IdBarNew' + IdBarNew);
                if (IdBarNew) {
                    IdBarNew[id].set(percent);
                    console.log('noticeUL' + noticeUL);
                    if (!$('.wys-imageUpload').is(':visible')) {
                        if (noticeUL) {
                            noticeUL.update({
                                title: false,
                                text:
                                    percent +
                                    '% file' +
                                    indexXHR.length +
                                    '/' +
                                    sumFiles,
                            });
                        } else {
                            RVwys.showNotifyUL();
                        }
                    }
                }
            },
            error: function (response, xhr) {
                var msg = xhr.status + ' ' + xhr.statusText;
                if ($('.wys-imageUpload').is(':visible')) {
                    msg += linkULERR;
                }
                console.pop.error(msg);
                RVwys.imageUL.clearNoticeUL(this.id);
            },
            complete: function (data, xhr) {
                //	console.log(data)

                var isValid = {
                    413: {
                        type: 'error',
                        code: '413',
                        message: '413 Payload too Large',
                    },
                    419: {
                        type: 'error',
                        code: '419',
                        message: '419 unknown status',
                    },
                    500: {
                        type: 'error',
                        code: '500',
                        message: '500 Internal Server Error',
                    },
                    200: {
                        type: 'success',
                        code: '200',
                        message: 'upload complete',
                    },
                    0: {
                        type: 'null',
                        code: '500',
                        message: 'cancel complete',
                    },
                };

                if (xhr == null) {
                    RVwys.imageUL.error(isValid['500']);
                    return;
                }
                if (data == null) {
                    RVwys.imageUL.error(isValid['500']);
                    return;
                }
                //data.id = data.id || this.params['id'];
                var status = xhr.status;
                if (data.status == 'error') {
                    status = '500';
                }

                console.log(xhr);
                var type = isValid[status] ? isValid[status].type : 'error';
                $.extend(true, isValid[status], data);
                console.log(isValid[status]);

                RVwys.imageUL[type](isValid[status]);
                RVwys.imageUL.clearNoticeUL(isValid[status].id);
            },
            allcomplete: function (response, xhr) {
                console.log('allcomplete');
                console.log(response);
                setTimeout(function () {
                    RVwys.imageUL.clearNoticeComAll();

                    var options = {};
                    options.title = 'Done!';
                    options.type = 'success';
                    options.text = '';
                    options.hide = true;
                    options.delay = 1200;
                    options.buttons = {
                        closer: true,
                        sticker: true,
                    };
                    options.icon = 'fa fa-check';
                    options.shadow = true;
                    if (noticeUL) {
                        noticeUL.update(options);
                        setTimeout(function () {
                            noticeUL.remove();
                            noticeUL = null;
                        }, 1300);
                    } else {
                        if (!$('.wys-imageUpload').is(':visible')) {
                            console.pop.notice(options);
                        }

                        // sumFiles=0;
                    }
                }, 250);
            },
        };

        //Error all plugins with both line // ฝากพี่ตั้ม Tanawat ดูด้วยนะคะ //Wi and the gangs
        var selectUL = UIkit.uploadSelect($('#upload-image-muti'), settings);
        var dropUL = UIkit.uploadDrop($('#upload-image-drop'), settings);

        $('.tipquestion').tooltip({
            tooltipClass: 'tooltip-styling',
            content: function () {
                //					 return $(this).prop('title');
                return $('.tooltiptext').html();
            },
            position: {
                my: 'left top',
                at: 'right+5 top-5',
                collision: 'none',
            },
        });

        $('.imageCategory').tooltip({
            tooltipClass: 'csstooltip',
            content: function () {
                return $(this).prop('title');
            },
            position: {
                my: 'left top',
                at: 'right+5 top-5',
                collision: 'none',
            },
        });

        $('.addtag').click(function () {
            //				alert('ss')
            if (!parent.$('#addTag').get(0)) {
                var addTagFolder = $(
                    '<div id="daddtag" title=""><input id="addTag" type="text" style="width: 115px;" value="" ></div>'
                );
                parent.$('.listMyfolder').append(addTagFolder);

                $('#daddtag').tooltip({
                    tooltipClass: 'tooltip-styling',
                    content: function () {
                        return $('.tooltiptext').html();
                    },
                    position: {
                        my: 'left top',
                        at: 'right+5 top-5',
                        collision: 'none',
                    },
                });

                parent.$('#addTag').focus();
                parent
                    .$('#addTag')
                    .blur(function () {
                        var tagname = parent.$('#addTag').val();
                        tagname = tagname.trim();

                        if (tagname == '') {
                            addTagFolder.remove();
                        } else {
                            var format = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]/g;
                            //							console.log("Validate Special :: "+format.test(tagname));

                            if (tagname.match(format) == null) {
                                if (parent.tagfolder.indexOf(tagname) == -1) {
                                    console.log(
                                        'tagfolder add :: ' + parent.tagfolder
                                    );
                                    console.log(
                                        'indexOf add :: ' +
                                            parent.tagfolder.indexOf(tagname)
                                    );
                                    addMyImageTagfolder(tagname);
                                } else {
                                    console.log(
                                        'indexOf not add :: ' +
                                            parent.tagfolder.indexOf(tagname)
                                    );

                                    if (!parent.$('.msgname').get(0)) {
                                        parent.$('.msgval').remove();
                                        var vali = $(
                                            '<p class="msgname" style="color:red;">' +
                                                rvLang('No already used') +
                                                '</p>'
                                        );
                                        parent.$('#daddtag').append(vali);
                                    } else {
                                        parent.$('#addTag').focus().select();
                                    }
                                }
                            } else {
                                if (!parent.$('.msgval').get(0)) {
                                    parent.$('.msgname').remove();
                                    var vali = $(
                                        '<p class="msgval" style="color:red;white-space: normal;">No special characters allowed</p>'
                                    );
                                    parent.$('#daddtag').append(vali);
                                } else {
                                    parent.$('#addTag').focus().select();
                                }
                            }
                        }
                    })
                    .keyup(function (e) {
                        //					 isKey ={'13':true,'84':true}
                        //if(isKey[e.keyCode]){
                        if (e.keyCode == '13') {
                            $(this).trigger('blur');
                        }
                    });

                console.log('AddtagInput : ' + parent.$('#addTag'));
            } else {
                parent.$('#addTag').focus();
                console.log('Focus : ' + parent.$('#addTag'));
            }
        });

        //		 		 var tagName = parent.$('.delTag').attr('tagName');
        //		 console.log("tagName : k : "+tagName);
        //		 RVwys.imagemanager.ClicksDelTagFolder(tagName);

        $('.fbmore').click(function () {
            var frameFB =
                parent.document.getElementById('fbAlbum').contentWindow;
            frameFB.postMessage('morephoto', '*');
        });

        $('.mini_insertImageInline').click(async function (e) {
            //alert('sadfasdf;k');
            //alert(parent.focusImage)
            parent.$('#frameBody').contents().find('.image-editor-tool').hide();
            RVwys.imagemanager.show();
            if (parent.$('.imageBoxView-free').html() == '') {
                //parent.$('#imageLib-tabs').tabs('option', 'active', 0);
                if (window.processListFreeImage) {
                    clearTimeout(window.processListFreeImage);
                }
                await RVwys.imagemanager.addView(parent.aFreeImages, 'all');
                parent.$('#imageLib-tabs').tabs('option', 'active', 0);
                /*
                setTimeout(function() {
                    parent.$('#imageLib-tabs').tabs('option', 'active', 0);
                }, 150);
                */
            }
        });

        $('#defactment').click(function (e) {
            $.ajax({
                method: 'GET',
                url: parent.wex.route_action.routeCommonDefactImage,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                        'content'
                    ),
                },
            })
                .done(function (data) {
                    alert('Data Saved: ' + data);
                })
                .fail(function () {
                    alert('error');
                });
        });

        $('.imageCategory').click(function () {
            if (window.processListFreeImage) {
                clearTimeout(window.processListFreeImage);
            }
            RVwys.imagemanager.addView(
                parent.aFreeImages,
                $(this).attr('cate_id')
            );
        });

        $('.backgroundCategory').click(function () {
            RVwys.imagemanager.eventClickTagBackground($(this));
        });

        $('#createMyFolder').click(function () {
            if (!$('.rowinput').get(0)) {
                var rowinput = $('<input class="rowinput">');
                rowinput
                    .one('blur', function () {
                        if ($(this).val() != '') {
                            // อย่าลืมสร้างajax create tag folder
                            $('.listMyfolder').prepend(
                                $(
                                    '<div class="myfolder">' +
                                        $(this).val() +
                                        '</div>'
                                )
                            );
                        }
                        $(this).remove();
                    })
                    .keypress(function (e) {
                        if (e.which == 13) {
                            $('.listMyfolder').prepend(
                                $(
                                    '<div class="myfolder">' +
                                        $(this).val() +
                                        '</div>'
                                )
                            );
                            $(this).remove();
                        }
                    });
                $('.listMyfolder').prepend(rowinput);
            }
            rowinput.focus();
        });
    });

    RVwys.plugin['imagemanager'] = true;
    RVwys.imagemanager = {};

    RVwys.imagemanager.eventClickTagBackground = function (oThis) {
        var type = oThis.attr('bgcate_id');
        RVwys.imagemanager.addViewBackground(type);
    };

    RVwys.imagemanager.uploadProgress = function (evt, imgJSON) {
        if (evt.lengthComputable) {
            var progress = Math.round((evt.loaded * 100) / evt.total);
        } else {
            progress = 'unable to compute';
        }
        var head = '';
        if (imgJSON.send.imageURL) {
            head += 'imageURL' + imgJSON.send.imageURL;
        }
        head += 'saveImagervwysiwyguikitdata:image/jpeg;base64';
        //alert(head)
        console.log('total->' + (evt.total - head.length) / 1024);
        var totalKB = Math.round((evt.total - head.length) / 1024);
        var perSEC = Math.round((evt.loaded - head.length) / 1024);
        var totalMB = Math.round(totalKB / 1024);
        var SEC = 'KB';
        var showTotal = totalKB + 'KB';
        if (totalKB >= 1000) {
            showTotal = (totalKB / 1024).toFixed(2) + 'MB';
            perSEC = (perSEC / 1024).toFixed(2) + 'MB';
            //SEC ='MB';
            //perSEC = Math.round(perSEC/1024);
        } else {
            perSEC = perSEC + SEC;
        }

        $('.progressFB').html(
            rvLang('copy to My image') + perSEC + ' | ' + showTotal
        );
    };

    RVwys.imagemanager.uploadComplete = function (imgJSON, xhr, callBack) {
        var data = jQuery.parseJSON(xhr.responseText);
        console.log('imageName->');
        //console.log(data);
        var imageName = data.name;
        var urlImage = data.src;
        //if (!parent.myimages) {
        Object.assign(parent.myimages, data.myimages);
        Object.assign(parent.storeimages, data.storeimages);
        //parent.tagfolder.push(data.storeimages) = data.tagfolder;
        //alert(storeimages['18121611_143469502857604_1345543127361703150_o'])
        //alert(parent.myimages)
        //}

        parent.$('.overlaypanel').remove();
        $('.overlaypanel').remove();
        var d = new Date();
        var n = d.getTime();
        parent.$('.myImageJSON').each(function () {
            var src = $(this)
                .attr('src')
                .replace(/\?n=\w*/gim, '');

            $(this).attr('src', src + '?n=' + n);
        });

        //		var imageName = data.name;
        //		var urlImage = data.src;
        //		var imagekey = data.imagekey;
        console.log('----- upload -----');
        console.log(data);
        console.log('imageName->' + data.src);
        var imageItemHTML = parent.$('#designMyImageItem').html();
        var oImageItem = $(imageItemHTML);
        oImageItem
            .find('.insert')
            .attr({ data: data.src, imagekey: data.imageKey });

        oImageItem
            .find('.remove')
            .attr({ imagename: data.name, imagekey: data.imagekey });
        var attr = { src: data.thumnail_url, id: imageName };
        //Object.assign(attr, parent.myimages[imageKey]);
        oImageItem.find('.imageItems').attr(attr);
        oImageItem = RVwys.imagemanager.eventMyImage(oImageItem);
        parent
            .$('.imageBoxView-myimage')
            .find('.workspace')
            .prepend(oImageItem);
        //curImageNew = $('<img crossorigin="anonymous" src="'+$(this).attr('data')+'"/>');
        if (callBack) {
            callBack(urlImage);
        } else {
            var curImageNew = $(
                '<img class="lazy" src="' + data.src + '"/>'
            ).one('load', function () {
                parent
                    .$('#frameBody')
                    .contents()
                    .find('#borderResize')
                    .css({
                        width: $(this).width(),
                        height: $(this).height(),
                    });
            });
            if (parent.focusImage) {
                parent.focusImage.replaceWith(curImageNew);
                parent.focusImage = curImageNew;
            } else {
                var curImageData = $(
                    '<img class="lazy" src="' + data.src + '">'
                ).one('load', function () {
                    parent
                        .$('#frameBody')
                        .contents()
                        .find('#borderResize')
                        .css({
                            width: $(this).width(),
                            height: $(this).height(),
                        });
                });
                parent.RVwys.InsertImage(curImageData);
            }
        }
        parent.$('.workspace').html('');
        parent.$('#imageLib-tabs').tabs('option', 'active', 0);
        $('.overlaypanel').remove();
        return;
    };

    RVwys.imagemanager.uploadImageDA = function (evt, imgJSON) {
        var fd = new FormData();
        fd.append('rvsMgr', 'rvwysiwyguikit');
        fd.append('rvsAct', 'saveImage');
        fd.append('thumnail', '');
        fd.append('tagFolder', '');
        fd.append('imageURL', imgJSON.send.imageURL);
        fd.append('override', imgJSON.send.isOverride);
        fd.append('imageName', imgJSON.send.imageName);
        fd.append('imageType', imgJSON.send.imageType);
        var xhr = new XMLHttpRequest();
        //xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        //req.setRequestHeader( "Content-type", "application/x-www-form-urlencoded" );

        xhr.addEventListener(
            'load',
            function (evt) {
                RVwys.imagemanager.uploadComplete(imgJSON, this);
            },
            false
        );

        var wysurl = parent.RVS_AJAX_INDEX;
        wysurl = wysurl.replace('rvwysiwyguikit', 'sitebuilder');
        console.log('==> Request Url: ' + wysurl);
        xhr.open('POST', wysurl);
        xhr.send(fd);
    };

    RVwys.imagemanager.uploadThumnailDA = function (evt, imgJSON) {
        var daForm2 = new FormData();
        var daRequest2 = new XMLHttpRequest();
        //da save thumbnail data
        var thumbanilData = imgJSON.send.thumnail.replace(
            /^data:image\/(png|jpg|gif|bmp);base64,/,
            '',
            ''
        );
        //rewrite data for thumbanil
        daForm2.append('action', 'edit');
        daForm2.append('path', '/.rvsitebuilder/tmp/');
        daForm2.append('text', thumbanilData);
        daForm2.append('filename', 'images_data_thumbnail.txt');
        //daRequest 2
        var wysurlDa = parent.UPLOAD_DIRECTADMIN_URL;
        daRequest2.open('POST', wysurlDa);
        daRequest2.upload.addEventListener(
            'load',
            function (evt) {
                RVwys.imagemanager.uploadImageDA(evt, imgJSON);
            },
            false
        );
        daRequest2.send(daForm2);
    };

    RVwys.imagemanager.uploadImage = function (imgJSON, callBack) {
        console.log(
            'fn: RVwys.imagemanager.uploadImage(imgJSON) File: imageManager/init.js'
        );
        console.log(imgJSON);
        var getPostMax = parseInt(parent.wex.phpconf.postMaxSize) * 1000000;

        if (imgJSON.send.data.length > getPostMax) {
            $('.overlaypanel').remove();
            parent.$('.overlaypanel').remove();

            var UI = parent.UIkit;
            var onInsert = function (e) {
                $('#imedit-upload').val('');
                parent.$('#imedit-upload').val('');
                modal.hide();
            };
            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Upload image') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        rvLang('this file or dimension is over') +
                        parent.wex.phpconf.postMaxSize +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Ok') +
                        '</button>',
                    '</div>',
                ].join(''),
                options
            );
            modal.element.find('.uk-button-success').on('click', function () {
                onInsert();
            });
            modal.show();

            return false;
        }

        // Convert xhr to axios axiosSaveImage
        axiosSaveImage(imgJSON.send)
            .then(result => {
                //close overlaypanel
                console.log(
                    'axios close overlaypanel File: imageManager/init.js'
                );
                $('.overlaypanel').remove();
                parent.$('.overlaypanel').remove();
                $('.overlay-image').remove();
                parent.$('.overlay-image').remove();

                parent.console.pop.success({
                    text: 'Save images success.',
                    delay: 5000,
                });
                // console.log(result.data.src);

                var regexLogo = /\/logo\./gi;
                if (result.data.src.match(regexLogo)) {
                    console.log('case: logo');
                    var d = new Date();
                    var n = d.getTime();
                    var imageUrl = result.data.src + '?v=' + n;
                    // display them
                    parent.$('.section-logo').attr('src', imageUrl);
                    parent
                        .$('.section-logo')
                        .css(
                            'background',
                            'url(' + imageUrl + ') no-repeat 50% / contain'
                        );
                    //display logo
                    parent
                        .$('#frameBody')
                        .contents()
                        .find('.rv_logo img')
                        .attr('src', imageUrl);

                    parent.wex.site.logo = imageUrl;
                }

                //logo-mobile
                var regexLogoMobile = /\/logo\-mobile\./gi;
                if (result.data.src.match(regexLogoMobile)) {
                    parent.wex.site.logo_mobile = imageUrl;
                }
                //set current logo
                RVwys.Brand.setCurrentLogoImage();
            })
            .catch(err => {
                // console.log(err);
                parent.console.pop.error({
                    text: 'Cannot save images',
                });
            });
    };

    RVwys.imagemanager.getBase64Image = function (img) {
        //alert(img)
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL('image/jpg');

        $(canvas).remove();
        return dataURL;
    };

    RVwys.imagemanager.getRatioThumbnail = function (img, scale) {
        //alert('thumb-'+img)
        var ratio = 1;

        scale = scale ? scale : 115;
        if (img.width > scale) {
            ratio = scale / img.width;
        } else if (img.height > scale) {
            ratio = scale / img.height;
        }

        return ratio;
    };

    RVwys.imagemanager.getBase64ImageThumbnail = function (img) {
        var canvas = document.createElement('canvas');
        var scale = 115;
        var ratio = RVwys.imagemanager.getRatioThumbnail(img, scale);
        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, scale, img.height * ratio);
        var dataURL = canvas.toDataURL('image/jpg');

        $(canvas).remove();
        return dataURL;
    };

    RVwys.imagemanager.show = function () {
        parent.$('.imageLib').show();
        parent.$('.wys-panel, .widget-blocks, .wys-dynamic').hide();
        parent
            .$('.ui-tabs-animate')
            .addClass('ui-tabs-animateOut')
            .removeClass('ui-tabs-animate');
    };
    RVwys.imagemanager.hide = function () {
        parent.$('.imageLib').hide();
        parent.isSectionBG = false;
        parent.isSiteBG = false;
        //parent.RVwys.showPanelAll();
        // parent.RVwys.showPanelActive();
    };

    RVwys.imagemanager.addTagBackground = function (data, type) {
        console.log(parent.$('#freeBackground .list'));
        var keyI = Object.keys(data).length;
        var item = parent.$('.backgroundCategory').length;
        if (item < keyI) {
            var i = 1;
            $.each(data, function (key) {
                console.log('key ->' + key);
                var keyTxt = key;
                key = key.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                var ListBackground = $(
                    '<div class="backgroundCategory"  bgcate_id="' +
                        keyTxt +
                        '" title="' +
                        rvLang(key) +
                        '"><lang>' +
                        key +
                        '</lang></div>'
                );

                ListBackground.click(function () {
                    RVwys.imagemanager.eventClickTagBackground($(this));
                });
                parent.$('#freeBackground .list').append(ListBackground);
                i++;
            });
            RVwys.imagemanager.addViewBackground('all');
            //  RVwys.imagemanager.FreeBackgroundList(keyI-1,0,Object.keys(data));
        }
    };

    RVwys.imagemanager.addViewBackground = function (type) {
        parent.$('.backgroundCategory').removeClass('category-active');
        parent
            .$('.backgroundCategory[bgcate_id=' + type + ']')
            .addClass('category-active');

        var groupImage = parent.aFreeBackground['bggroup'];
        var newImageDataObjBG = {};
        var arrImageData = [];
        // Object.assign(newImageDataObj, v.split(","));
        parent.$('.imageBoxView-background').html('');

        if (type == 'all') {
            $.each(groupImage, function (typeKey, Catval) {
                $.each(Catval, function (bgKey, catKey) {
                    $.each(catKey['image'], function (imgKey, imgVal) {
                        var ImgPath =
                            typeKey +
                            '/' +
                            bgKey +
                            '/' +
                            imgVal +
                            '.' +
                            catKey['type'];
                        arrImageData.push(ImgPath);
                    });
                });
            });

            Object.assign(newImageDataObjBG, arrImageData);
        } else {
            $.each(groupImage[type], function (bgKey, catKey) {
                $.each(catKey['image'], function (imgKey, imgVal) {
                    var ImgPath =
                        type +
                        '/' +
                        bgKey +
                        '/' +
                        imgVal +
                        '.' +
                        catKey['type'];
                    arrImageData.push(ImgPath);
                });
            });

            Object.assign(newImageDataObjBG, arrImageData);
        }

        var maxItem = Object.keys(newImageDataObjBG).length;
        RVwys.imagemanager.FreeBackgroundList(
            maxItem - 1,
            0,
            newImageDataObjBG
        );
    };

    RVwys.imagemanager.addView = function (data, type) {
        console.log('RVwys.imagemanager.addView');
        console.log('type: ' + type);
        //clear
        $('.imageCategory').removeClass('category-active');
        //add class by cate_id=value
        $('div[cate_id=' + type + ']').addClass('category-active');
        var ix = Object.keys(data.category_text).length;
        var i = 0;
        $('.imageBoxView-free').html('');
        if (ix) {
            var newImageDataObj = {};
            if (type == 'all') {
                $.each(data.category_text, function (k, v) {
                    Object.assign(newImageDataObj, v.split(','));
                });
            } else {
                Object.assign(
                    newImageDataObj,
                    data.category_text[type].split(',')
                );
            }
            var maxItem = Object.keys(newImageDataObj).length;
            RVwys.imagemanager.listFreeImage(maxItem - 1, 0, newImageDataObj);
        }
    };

    var facebookImageView = '';

    window.addEventListener('message', function (event) {
        if (event.origin == 'https://social.rvsitebuilder.com') {
            //alert(event.data)
            var data = event.data;
            try {
                data = jQuery.parseJSON(data); //JSON.parse(event.data);
                //alert(data.action)
            } catch (e) {
                console.log(e);
                return;
            }

            console.log('fb photo->');
            console.log(data);
            //alert(data.action)
            switch (data.action) {
                case 'fbmore':
                    var fbmore = $(
                        '<div class="fbmore checkleft"><button limit=100 offset=100 class="btn-input padlt">More</button></div>'
                    );
                    fbmore.find('button').click(function () {
                        var frameFB =
                            parent.document.getElementById(
                                'fbAlbum'
                            ).contentWindow;
                        frameFB.postMessage('morephoto', '*');
                        $(this).remove();
                    });
                    $('.fbview').append(fbmore);

                    break;
                case 'fbclear':
                    $('.fbview').html('');
                    $('.fbmore').hide();

                    break;

                case 'fblogin':
                    var fbMsgView =
                        '<div class="fb-msgSelectAlbum msgblock-info-im">' +
                        rvLang('select album facebook left menu') +
                        '</lang></div><div class="bg-categoyfacebook"></div>';
                    $('.fbview').html(fbMsgView);

                    break;
                case 'fblogout':
                    var fbMsgView = $(
                        '<div class="fb-msgSelectAlbum">' +
                            rvLang('Please login Facebook') +
                            '</lang> </div>'
                    )
                        .find('a')
                        .click(function () {
                            var frameFB =
                                parent.document.getElementById(
                                    'fbAlbum'
                                ).contentWindow;
                            frameFB.postMessage('triggerLoginFB', '*');
                        })
                        .end();
                    $('.fbview').html('').append(fbMsgView);

                    $('.fbmore').hide();
                    break;
                case 'fblogin':
                    var fbMsgView =
                        '<div class="fb-msgSelectAlbum msgblock-info-im">' +
                        rvLang('select album facebook left menu') +
                        '</lang></div><div class="bg-categoyfacebook"></div>';
                    $('.fbview').html(fbMsgView);

                    break;
                case 'fblogout':
                    var fbMsgView = $(
                        '<div class="fb-msgSelectAlbum">' +
                            rvLang('Please login Facebook') +
                            '</lang> </div>'
                    )
                        .find('a')
                        .click(function () {
                            var frameFB =
                                parent.document.getElementById(
                                    'fbAlbum'
                                ).contentWindow;
                            frameFB.postMessage('triggerLoginFB', '*');
                        })
                        .end();
                    $('.fbview').html('').append(fbMsgView);

                    $('.fbmore').hide();
                    break;
                case 'viewPhoto':
                    var fbImage = $(
                        '<div class="imageBlock">' +
                            '<img class="imageItems" src="' +
                            parent.wex.url.WYS_IMG_URL +
                            'images/spacer.gif"' +
                            ' width="100%" id="fb-photo' +
                            data.id +
                            '" " ' +
                            ' style="background:#ffffff url(' +
                            data.picture +
                            ')  no-repeat 50% / contain;"> ' +
                            ' <div class="imageTools" style="">' +
                            '<span class=" icon-padd uk-icon-pencil" style="color:#fff;display:none;"></span>' +
                            '<span title="Insert and Download to My Images" class="insert icon-padd uk-icon-medium uk-icon-download"' +
                            'style="color:#fff;font-size: 150%"' +
                            'data="' +
                            data.source +
                            '">' +
                            '</span>' +
                            '</div></div>'
                    );
                    //alert(fbImage.find('.insert').get(0))
                    fbImage.find('.insert').click(function () {
                        //$('#frameBody').contents().find('.layoutResize').remove();

                        var overlaypanel = $(
                            '<div class="overlaypanel"><p class="progressFB">' +
                                rvLang('copy to My image') +
                                '</p></div>'
                        ).css({
                            width: $('body').width(),
                            height: $('body').height(),
                        });

                        $('body').prepend(overlaypanel);
                        //$('.imageLib').prepend(overlayImageMGR);

                        fbImage = $(
                            '<img crossorigin="anonymous" class="lazy" src="' +
                                $(this).attr('data') +
                                '"/>'
                        ).one('load', function () {
                            var data = RVwys.imagemanager.getBase64Image(
                                $(this).get(0)
                            );
                            var thumbnail =
                                RVwys.imagemanager.getBase64ImageThumbnail(
                                    $(this).get(0)
                                );
                            var aImageURL = $(this).attr('src').split('/');
                            var imageType = data
                                .replace(/^data\:image\//gim, '')
                                .replace(/\;base64(.*)/gim, '');
                            var name = aImageURL[aImageURL.length - 1].replace(
                                /\?(.*)/gim,
                                ''
                            );
                            if (imageType == 'jpeg') {
                                imageType = 'jpg';
                            }
                            var curImageNew = $(
                                '<img crossorigin="anonymous" class="lazy" src="' +
                                    data +
                                    '"/>'
                            );

                            //parent.RVwys.InsertImage(data);

                            var sendImage = {
                                send: {
                                    data: data,
                                    thumnail: thumbnail,
                                    imageURL: $(this).attr('src'),
                                    override: 0,
                                    imageName: name,
                                    imageType: imageType,
                                    tagFolder: 'Facebook',
                                },
                            };

                            var callBack = parent.isSectionBG
                                ? function (URL) {
                                      var sectionActive = $('.mgActive').get(0)
                                          ? $('.mgActive')
                                          : $('#frameBody')
                                                .get(0)
                                                .contentWindow.$('.mgActive');
                                      sectionActive.parent().css({
                                          'background-image':
                                              'url(' + URL + ')',
                                          'background-repeat': 'no-repeat',
                                          'background-size': 'cover',
                                          'background-attachment': 'fixed',
                                      });
                                      parent
                                          .$('.lastModified ,.workspace')
                                          .html('');
                                  }
                                : false;
                            RVwys.imagemanager.uploadImage(sendImage, callBack);
                        });

                        /*
						curImageNew = $('<img crossorigin="anonymous" src="'+$(this).attr('data')+'"/>');

						//alert(focusImage)

						if (parent.focusImage) {
							parent.focusImage.replaceWith(curImageNew);
							parent.focusImage = curImageNew;
						} else {
							parent.RVwys.InsertImage($(this).attr('data'));
						}
							 */
                        $('.layoutResize').remove();
                    });
                    $('.fbview').append(fbImage);

                    break;
                default:
                    break;
            }
        }
    });

    RVwys.imagemanager.listfacebookImage = function () {
        // $('.fbview').append(obj);
        facebookImageView = setTimeout(function () {
            //alert(parent.document.getElementById("fbAlbum"))
            var frameFB =
                parent.document.getElementById('fbAlbum').contentWindow;
            frameFB.postMessage('message', '*');
        }, 500);
    };

    RVwys.imagemanager.FreeBackgroundList = function (iTatal, cLimit, data) {
        console.log('BGName->' + +iTatal);
        var imagePath = data[iTatal];

        if (imagePath == undefined) {
            RVwys.currentImageManager(curImage);
            return false;
        }

        if (cLimit > window.displayLimitImage) {
            window.cacheFreeImageBGMore = data;
            console.log('free Background ' + cLimit);

            var fmMore = $(
                '<div class="freeMore checkleft"><button now = "' +
                    iTatal +
                    '" class="btn-input padlt">More</button></div>'
            );
            parent.$('.imageBoxView-background').append(fmMore);
            parent
                .$('.imageBoxView-background')
                .find('button')
                .click(function (e) {
                    RVwys.imagemanager.FreeBackgroundList(
                        $(this).attr('now'),
                        0,
                        window.cacheFreeImageBGMore
                    );
                    $(this).remove();
                });
            RVwys.currentImageManager(curImage);
            return false;
        }

        if (iTatal >= 0) {
            var urlImageItem =
                parent.wex.cdn.LIBRARY_URL + '/freebackground/' + imagePath;
            var urlImageThumbnails =
                parent.wex.cdn.LIBRARY_URL + '/freebackground/' + imagePath;
            var imageItemHTML = parent.$('#designFreeImageItem').html();
            var oImageItem = $(imageItemHTML);
            console.log(imagePath);

            var IdOitem = imagePath.replace(/\//g, '_').match(/(.*)?[0-9]/gim);
            var attr = {
                src: urlImageThumbnails,
                id: 'img_' + IdOitem,
            };
            var CateBG = imagePath.match(/^([a-zA-Z0-9]*)/g);

            oImageItem.find('.imageItems').attr(attr);
            oImageItem
                .find('.insert')
                .attr({ data: urlImageItem, imagekey: CateBG });
            oImageItem.addClass('rv_' + CateBG);
            oImageItem = RVwys.imagemanager.eventMyImage(oImageItem);
            parent.$('.imageBoxView-background').append(oImageItem);

            iTatal--;
            cLimit++;

            RVwys.imagemanager.FreeBackgroundList(iTatal, cLimit, data);

            return false;
        }
    };

    RVwys.imagemanager.listFreeImage = function (iTatal, cLimit, data) {
        //console.log('imageName-> ' + +iTatal);
        var imageName = data[iTatal];

        if (imageName == undefined) {
            RVwys.currentImageManager(curImage);
            return false;
        }

        if (cLimit > window.displayLimitImage) {
            window.cacheFreeImageMore = data;
            console.log('free image' + cLimit);
            var fmMore = $(
                '<div class="freeMore checkleft"><button now = "' +
                    iTatal +
                    '" class="btn-input padlt">More</button></div>'
            );
            parent.$('.imageBoxView-free').append(fmMore);
            parent
                .$('.imageBoxView-free')
                .find('button')
                .click(function (e) {
                    RVwys.imagemanager.listFreeImage(
                        $(this).attr('now'),
                        0,
                        window.cacheFreeImageMore
                    );
                    $(this).remove();
                });
            if (curImage) {
                RVwys.currentImageManager(curImage);
            }
            return false;
        }
        if (iTatal >= 0) {
            //alert(iIndex+'<= ' +iTatal)
            var imgSize = {};
            imgSize['S'] = '<span class="insert icon-padd icon-num">400</span>';
            imgSize['M'] = '<span class="insert icon-padd icon-num">800</span>';
            imgSize['L'] =
                '<span class="insert icon-padd icon-num">1200</span>';

            var imgItem = parent.aFreeImages['size_text'][imageName];
            var urlImagesss = (imgItem['M']['path'] + '/' + imageName).replace(
                /\-dot\-/gim,
                '.'
            );
            var urlImage = (
                imgItem['M']['path'].replace('/M', '') +
                '/wpThumbnails/' +
                imageName
            ).replace(/\-dot\-/gim, '.');
            var imageItemHTML = parent.$('#designImageItem').html();
            //
            //alert(imageItemHTML)

            var oImageItem = $(imageItemHTML);
            //alert(imgItem.length)
            $.each(imgItem, function (k, v) {
                var urlImageItem =
                    parent.wex.cdn.LIBRARY_URL +
                    '/' +
                    (v.path + '/' + imageName).replace(/\-dot\-/gim, '.');
                oImageItem
                    .find('.imageTools')
                    .append($(imgSize[k]).attr('data', urlImageItem));
            });

            oImageItem
                .find('.imageItems')
                .attr({
                    src: parent.wex.cdn.LIBRARY_URL + '/' + urlImage,
                    id: imageName,
                })
                .one('load', function () {
                    $(this)
                        .attr({
                            src:
                                parent.wex.url.WYS_IMG_URL +
                                'images/spacer.gif',
                            style:
                                'background:#ffffff url(' +
                                parent.wex.cdn.LIBRARY_URL +
                                '/' +
                                urlImage +
                                ')  no-repeat 50% / contain;',
                        })
                        .show();
                })
                .click(function () {
                    parent
                        .$('.imageLib')
                        .find('.rvCurrentImage')
                        .removeClass('rvCurrentImage');
                    $(this).addClass('rvCurrentImage');
                })
                .end()
                .find('.insert')
                .click(function (e) {
                    window.isTexture = $(this)
                        .closest('.freebg-category')
                        .is('.rv_texture');

                    if (parent.isSectionBG) {
                        console.log('parent.isSectionBG');
                        if (parent.rowParallaxSlide) {
                            RVwys.imagemanager.slideBG($(this));
                        } else {
                            RVwys.imagemanager.sectionBG($(this));
                        }
                    } else {
                        if (parent.isSiteBG) {
                            RVwys.SiteTheme.rowSiteBG($(this));
                        } else {
                            var curImageNew = $(
                                '<img crossorigin ="anonymous" class="lazy" src="' +
                                    $(this).attr('data') +
                                    '"/>'
                            );
                            if (parent.focusImage) {
                                parent.focusImage.replaceWith(curImageNew);
                                parent.focusImage = curImageNew;
                            } else {
                                parent.RVwys.InsertImage(curImageNew);
                            }
                            $('.layoutResize').remove();
                        }
                    }
                });

            parent.$('.imageBoxView-free').append(oImageItem);
            //parent.$('.imageBoxView-free').append($('<div style=""><img src="'+parent.LIBRARY_URL+'/'+urlImage+'" width="100%"/></div>'));
            iTatal--;
            cLimit++;
            window.processListFreeImage = setTimeout(function () {
                RVwys.imagemanager.listFreeImage(iTatal, cLimit, data);
            }, 10);
            return false;
        }
    };
    RVwys.imagemanager.slideBG = function (othis) {
        var imgSlide = $('[data-banner=' + parent.currentSlide + ']').get(0)
            ? $('[data-banner=' + parent.currentSlide + ']')
            : $('#frameBody')
                  .get(0)
                  .contentWindow.$('[data-banner=' + parent.currentSlide + ']');

        //		tag Img
        imgSlide.find('img').first().attr('src', $(othis).attr('data'));

        //		uk-Slide- background
        imgSlide.children('.uk-cover-background').css({
            'background-image': 'url(' + $(othis).attr('data') + ')',
        });

        //		img.parent().find('div').css({
        //			'background-image':'url('+$(othis).attr('data')+')',
        //		})

        if (window.isTexture) {
            imgSlide
                .css({
                    'background-repeat': 'repeat',
                    'background-size': 'auto',
                })
                .removeAttr('data-uk-parallax');
        }
        parent
            .$('.wys-rowFour')
            .find('.section-bg')
            .css({
                background:
                    'url(' +
                    $(othis).attr('data') +
                    ') no-repeat 50% / contain',
            });
    };

    RVwys.imagemanager.sectionBG = function (othis) {
        //alert($('body').html())

        var sectionActive = $('.mgActive').get(0)
            ? $('.mgActive')
            : $('#frameBody').get(0).contentWindow.$('.mgActive');

        if (parent.isBlockBG) {
            sectionActive = parent.RVwys.getBlockBG;
        }

        var isCssRGBA = sectionActive.css('background-color');
        //alert(isCssRGBA)
        //alert(sectionActive.parent().css('background-color'))
        var validateRGB = {
            'rgb(': true,
            'rgba(0,0,0,0)': true,
        };

        if (isCssRGBA == '') {
            var repairRGBA = 'rgba(255,255,255,.2)';
        }

        repairRGBA = isCssRGBA.replace(/rgb\((.*?)\)/gim, 'rgba($1,.2)');

        if (window.isFooterBG) {
            sectionActive
                .find('#footerTemplate')
                .css('background-color', repairRGBA);
        } else {
            sectionActive.css('background-image', '');
            sectionActive.css('background-color', repairRGBA);
        }

        if (parent.isBlockBG) {
            sectionActive.css({
                'background-image': 'url(' + $(othis).attr('data') + ')',
                'background-repeat': 'no-repeat',
                'background-size': 'cover',
                'background-attachment': 'fixed',
                'background-position': 'center',
            });

            if (window.isTexture) {
                sectionActive
                    .css({
                        'background-repeat': 'repeat',
                        'background-size': 'auto',
                    })
                    .removeAttr('data-uk-parallax');
            }

            RVwys.setCurrentBlockBGIMAGE(sectionActive);
        } else {
            sectionActive.parent().css({
                'background-image': 'url(' + $(othis).attr('data') + ')',
                'background-repeat': 'no-repeat',
                'background-size': 'cover',
                'background-attachment': 'fixed',
                'background-position': 'center',
            });

            if (window.isTexture) {
                sectionActive
                    .parent()
                    .css({
                        'background-repeat': 'repeat',
                        'background-size': 'auto',
                    })
                    .removeAttr('data-uk-parallax');
            }

            RVwys.setCurrentBGIMAGE(sectionActive);
        }
    };

    RVwys.imagemanager.eventMyImage = function (oItem) {
        var urlImage = oItem.find('.imageItems').attr('src');
        console.log(' fn:imagemanager.eventMyImage urlImage = ', urlImage);
        var d = new Date();
        var n = d.getTime();

        oItem
            .find('.imageItems')
            .one('load', function () {
                $(this)
                    .attr({
                        src: parent.wex.url.WYS_IMG_URL + 'images/spacer.gif',
                        style:
                            'background:#ffffff url(' +
                            $(this).attr('src') +
                            '?n=' +
                            n +
                            ')  no-repeat 50% / contain;',
                    })
                    .show();
            })
            .on('click', function (e) {
                parent
                    .$('.imageLib')
                    .find('.rvCurrentImage')
                    .removeClass('rvCurrentImage');
                $(this).addClass('rvCurrentImage');

                parent.$('.imageBlock,.listMyfolder').disableSelection();
            })
            .end()
            .find('.insert')
            .on('click', function () {
                console.log('====================================');
                console.log($(this));
                console.log('====================================');
                //parent.$('#frameBody').contents().find('.layoutResize').remove();
                window.isTexture = $(this)
                    .closest('.freebg-category')
                    .is('.rv_texture');

                if (parent.isSectionBG) {
                    if (parent.rowParallaxSlide) {
                        RVwys.imagemanager.slideBG($(this));
                    } else {
                        RVwys.imagemanager.sectionBG($(this));
                    }
                } else {
                    if (parent.isSiteBG) {
                        RVwys.SiteTheme.rowSiteBG($(this));
                    } else {
                        var curImageNew = $(
                            '<img crossorigin="anonymous" class="lazy" src="' +
                                $(this).attr('data') +
                                '"/>'
                        ).one('load', function () {
                            parent
                                .$('#frameBody')
                                .contents()
                                .find('#borderResize')
                                .css({
                                    width: $(this).width(),
                                    height: $(this).height(),
                                });
                        });

                        if (parent.focusImage) {
                            parent.focusImage.replaceWith(curImageNew);
                            parent.focusImage = curImageNew;
                        } else {
                            var curImageData = $(
                                '<img crossorigin="anonymous" class="lazy" src="' +
                                    $(this).attr('data') +
                                    '">'
                            ).one('load', function () {
                                parent
                                    .$('#frameBody')
                                    .contents()
                                    .find('#borderResize')
                                    .css({
                                        width: $(this).width(),
                                        height: $(this).height(),
                                    });
                            });
                            parent.RVwys.InsertImage(curImageData);
                        }
                    }
                }
            })
            .end()
            .find('.medit-full')
            .on('click', function (e) {
                var imageURL = $(this).parent().find('.insert').attr('data');
                console.log('RVwys.imageEditorFull File:imageManager/init.js');
                RVwys.imageEditorFull(imageURL);
                //RVwys.imageEditFull();
                //parent.imageFull();
            })
            .end()
            .find('.remove')
            .on('click', function (e) {
                //	 		$input->imageName = $req->get ( 'imagename' );
                //	 		$input->imageKey = $req->get ( 'imagekey' );

                var curThisM = $(this);
                var UI = parent.UIkit;
                var onInsert = function (e) {
                    var sectionActive = $('.mgActive').get(0)
                        ? $('.mgActive')
                        : $('#frameBody').get(0).contentWindow.$('.mgActive');

                    var isCssRGBA = sectionActive.css('background-color');
                    //alert(isCssRGBA)
                    //alert(sectionActive.parent().css('background-color'))
                    var validateRGB = {
                        'rgb(': true,
                        'rgba(0,0,0,0)': true,
                    };
                    if (isCssRGBA == '') {
                        var repairRGBA = 'rgba(255,255,255)';
                    }

                    repairRGBA = isCssRGBA.replace(
                        /rgb\((.*?)\)/gim,
                        'rgba($1,.2)'
                    );
                    sectionActive.css('background-color', repairRGBA);

                    sectionActive.parent().removeAttr('style');

                    console.log(
                        'Event: onInsert img:src= ' +
                            parent.wex.url.rvsThemImage
                    );
                    var overlaypanel = $(
                        '<div class="overlaypanel">' +
                            '<img class="loading" src="' +
                            parent.wex.url.WYS_IMG_URL +
                            'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                            '</div>'
                    ).css({
                        width: $('body').width(),
                        height: $('body').height(),
                    });

                    parent.$('body').append(overlaypanel);
                    console.log('image Store');
                    console.log(parent.storeimages);
                    var frmParam = ''; //'&rvsMgr=rvwysiwyguikit&rvsAct=deleteImage';
                    frmParam += '&imageName=' + curThisM.attr('imagename');
                    frmParam += '&imageKey=' + curThisM.attr('imagekey');
                    frmParam +=
                        '&imagePath=' +
                        parent.storeimages[curThisM.attr('imagekey')]['path'];

                    var oRemoveImage = curThisM.parent().parent();

                    axiosDeleteImage(frmParam)
                        .then(result => {
                            var key = result.data.imageKey;
                            delete parent.storeimages[key];
                            delete parent.myimages[key];
                            parent
                                .$(`#my${result.data.imageName}`)
                                .parent()
                                .remove();
                            oRemoveImage.remove();
                            parent.$('.overlaypanel').remove();
                            var keyS = result.data.imageName.replace(
                                '.',
                                '\\.'
                            );
                            $('img[src*=' + keyS + ']').each(function () {
                                var src = $(this).attr('src');
                                var date = new Date();
                                var timeNow = date.getTime();

                                $(this).attr('src', src + '?n=' + timeNow);
                            });
                        })
                        .catch(err => {
                            console.log('err: ', err);
                        });

                    modal.hide();
                };
                var oncancel = function () {
                    modal.hide();
                };
                var options = {
                    bgclose: false,
                    keyboard: false,
                    modal: false,
                };

                var modal = UI.modal.dialog(
                    [
                        `<div class="uk-margin uk-modal-header"><h2>${rvLang(
                            'Delete image'
                        )}</h2><span class="uk-modal-close uk-icon-close"></span></div>
										  <div class="uk-margin uk-modal-content">CAUTION : To delete this image, it will delete the current use on your website as well.</div>
			                              <div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">${rvLang(
                                              'Ok'
                                          )}</button>
			                              <button class="uk-button js-modal-confirm-cancel">${rvLang(
                                              'Cancel'
                                          )}</button></div>`,
                    ].join(''),
                    options
                );
                modal.element
                    .find('.js-modal-confirm-cancel')
                    .on('click', function () {
                        oncancel();
                    })
                    .end()
                    .find('.uk-button-success')
                    .on('click', function () {
                        onInsert();
                    });
                modal.show();
            });

        return oItem;
    };

    RVwys.imagemanager.clicksTagFolder = function (e) {
        parent.$('.tagFolder').removeClass('category-active');

        parent
            .$('.tagFolder[key=' + $(this).attr('key') + ']')
            .addClass('category-active');

        parent.$('.lastModified ,.workspace').html('');
        RVwys.imagemanager.findMyImageBytagFolder($(this).attr('tagName'));
    };

    RVwys.imagemanager.myImageTagFolder = function () {
        console.log('tagfolder :: ' + parent.tagfolder);
        parent.$('.listMyfolder').html('');

        /*if(parent.tagfolder[0] == 'allImages'){
			parent.tagfolder[0] = 'All Images';
			var tag = parent.tagfolder;
			RVwys.imagemanager.VerTagFolder(tag);
		}*/

        $.each(parent.tagfolder, function (k, v) {
            // alert(v)
            //			 var itemTagFolder = $('<div class="tagFolder" tagName="'+v+'">'+rvLang(v)+'</div>'); แก้ไขไม่ต้องแปล Lang
            var itemTagFolder = $(
                '<div class="tagFolder" key="' +
                    k +
                    '" tagName="' +
                    v +
                    '"><span title="' +
                    v +
                    '">' +
                    v +
                    '</span></div>'
            );
            itemTagFolder.click(RVwys.imagemanager.clicksTagFolder);
            parent.$('.listMyfolder').append(itemTagFolder);

            RVwys.imagemanager.initTagfolderdrop(itemTagFolder);
            if (k == 0) {
                parent.$('.tagFolder').addClass('category-active');
                parent
                    .$('.tagFolder')
                    .find('span')
                    .attr('title', '' + rvLang(v) + '');
            }

            if (k > 1) {
                var editTag = $(
                    '<li title="Rename" class="edittag uk-icon uk-icon-pencil" key="' +
                        k +
                        '" tagName="' +
                        v +
                        '" style="    cursor: pointer;float: right;    margin-top: -17px;margin-right: 25px;" ></li>'
                );
                parent.$('.listMyfolder').append(editTag);
                editTag.click(RVwys.imagemanager.ClicksEditTagFolder);

                var delTagFolder = $(
                    '<li title="Delete" key="' +
                        k +
                        '" tagName="' +
                        v +
                        '" class="delTag uk-icon uk-icon-close"></li>'
                );
                parent.$('.listMyfolder').append(delTagFolder);

                delTagFolder.click(RVwys.imagemanager.ClicksDelTagFolder);

                //				 var EditTagFolder = $('<span title="Edit" class="uk-icon uk-icon-pencil "></span>');
                //				 parent.$('.listMyfolder').append(EditTagFolder);
                console.log('delTagFolder : ' + v);
            }
        });
    };

    RVwys.imagemanager.VerTagFolder = function (tagfolder) {
        //		alert(tagfolder);
        var frmParam = '&rvsMgr=rvwysiwyguikit&rvsAct=VersionTagFolder';
        frmParam += '&tagfolder=' + tagfolder;

        var wysurl = parent.RVS_AJAX_INDEX;
        wysurl = wysurl.replace('rvwysiwyguikit', 'sitebuilder');

        parent.jQuery.sitebuilder.Ajax.connect(frmParam, {
            url: wysurl,
            waitDialog: function (ev) {},
            callback: {
                doError: function (data) {
                    alert('Error DeleteTag : ' + data);
                },
                doSuccess: function (data) {},
            },
        });
    };

    RVwys.imagemanager.ClicksDelTagFolder = function (tagName, keyTag) {
        var overlaypanel = $(
            '<div class="overlaypanel">' +
                '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                '</div>'
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });

        var tagName = $(this).attr('tagName');
        var keyTag = $(this).attr('key');
        console.log('tagName :: ' + tagName);
        console.log('keyTag :: ' + keyTag);
        var curThisR = $(this);
        var UI = parent.UIkit;
        var onInsert = function (e) {
            //Event deletetagfolder
            $.ajax({
                url:
                    parent.wex.route_action.routeCommonUrl + '/deletetagfolder',
                type: 'post',
                data: {
                    tagfolderName: tagName,
                    tagKey: keyTag,
                },
                headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
            })
                .done(function (data) {
                    //done do
                    parent.tagfolder = data.aFolderValue;
                    console.log('tagfolder Delect :: ' + parent.tagfolder);
                    parent.$('.overlaypanel').remove();
                    curThisR.remove();
                    parent.$(".tagFolder[key='" + data.key + "']").remove();
                    parent.$(".edittag[key='" + data.key + "']").remove();

                    console.pop.success({
                        text: 'Delete Success',
                        delay: 5000,
                    });
                })
                .fail(function (jqXHR, textStatus) {
                    //fail do
                    // alert("Error DeleteTag : "+textStatus);
                    parent.$('.overlaypanel').remove();
                });

            modal.hide();
        };

        oncancel = function () {
            modal.hide();
        };

        var options = {
            bgclose: false,
            keyboard: false,
            modal: false,
        };

        var modal = UI.modal.dialog(
            [
                '<div class="uk-margin uk-modal-header"><h2>' +
                    rvLang('Delete Tag') +
                    '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                '<div class="uk-margin uk-modal-content">' +
                    rvLang('Are you sure you want to delete this tag') +
                    '</div>',
                '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                    rvLang('Ok') +
                    '</button>',
                '<button class="uk-button js-modal-confirm-cancel">' +
                    rvLang('Cancel') +
                    '</button></div>',
            ].join(''),
            options
        );
        modal.element
            .find('.js-modal-confirm-cancel')
            .on('click', function () {
                oncancel();
            })
            .end()
            .find('.uk-button-success')
            .on('click', function () {
                onInsert();
                parent.$('body').append(overlaypanel);
            });
        modal.show();
    };

    RVwys.imagemanager.ClicksEditTagFolder = function (key, name) {
        var edit = $(this);
        console.log('this === ' + edit.html());
        var tagName = $(this).attr('tagName');
        var keyTag = $(this).attr('key');
        var beforeTag = parent.$(".tagFolder[key='" + keyTag + "']");
        var deltag = parent.$(".delTag[key='" + keyTag + "']");
        var beTag = beforeTag.attr('tagname');

        var editTagFolder = $(
            '<div id="edittag" title=""><input id="ediTag" type="text" style="width: 115px;" value="' +
                beTag +
                '"></div>'
        );
        parent.$(beforeTag).after(editTagFolder);

        beforeTag.hide();
        deltag.hide();
        $(this).hide();

        //

        parent.$('#ediTag').focus().select();

        parent.$('#edittag').tooltip({
            tooltipClass: 'tooltip-styling',
            content: function () {
                return $('.tooltiptext').html();
            },
            position: {
                my: 'left top',
                at: 'right+5 top-5',
                collision: 'none',
            },
        });

        parent
            .$('#ediTag')
            .blur(function () {
                var tagname = parent.$('#ediTag').val();
                tagname = tagname.trim();
                console.log('beTag :: ' + beTag);

                var format = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]/g;
                console.log('Format :: ' + format);
                console.log('Validate Special :: ' + tagname.match(format));

                if (tagname.match(format) == null) {
                    if (tagname != '') {
                        if (parent.tagfolder.indexOf(tagname) == -1) {
                            console.log('tagfolder add :: ' + parent.tagfolder);
                            console.log(
                                'indexOf add :: ' +
                                    parent.tagfolder.indexOf(tagname)
                            );
                            updateTagname(keyTag, tagname, beTag);
                        } else {
                            if (tagname != beTag) {
                                if (!parent.$('.msgname').get(0)) {
                                    parent.$('.msgval').remove();
                                    var vali = $(
                                        '<p class="msgname" style="color:red;"> ' +
                                            rvLang('No already used') +
                                            '</p>'
                                    );
                                    parent.$('#edittag').append(vali);
                                } else {
                                    parent.$('#ediTag').focus().select();
                                }
                            } else {
                                beforeTag.show();
                                deltag.show();
                                parent
                                    .$('.edittag[key="' + keyTag + '"]')
                                    .show();
                                parent.$('#edittag').remove();
                            }

                            console.log(
                                'indexOf not add :: ' +
                                    parent.tagfolder.indexOf(tagname)
                            );
                        }

                        console.log('tagname EditTagfolder : ' + tagname);
                    } else {
                        beforeTag.show();
                        deltag.show();
                        parent.$('.edittag[key="' + keyTag + '"]').show();
                        parent.$('#edittag').remove();
                    }
                } else {
                    if (!parent.$('.msgval').get(0)) {
                        parent.$('.msgname').remove();
                        var vali = $(
                            '<p class="msgval" style="color:red;white-space: normal;">No special characters allowed</p>'
                        );
                        parent.$('#edittag').append(vali);
                    } else {
                        parent.$('#edittag').focus().select();
                    }
                }
            })
            .keyup(function (e) {
                var isKey = { 13: true, 84: true };
                //  if(e.keyCode == '13'){
                if (isKey[e.keyCode]) {
                    $(this).trigger('blur');
                }
            });
    };

    function updateTagname(keytag, tagname, befortag) {
        console.log('updateTagname -----------:');
        console.log('keytag:' + keytag);
        console.log('tagname:' + tagname);
        console.log('befortag:' + befortag);

        var tagLike = new RegExp(befortag, 'img');
        var aDataUpdate = {};

        $.each(parent.myimages, function (k, v) {
            if (v.tagFolder.search(tagLike) != -1) {
                aDataUpdate[k] = v;
                parent.myimages[k]['tagFolder'] = tagname;
            }
        });

        console.log('aDataUpdate');
        console.log(aDataUpdate);
        var overlaypanel = $(
            '<div class="overlaypanel">' +
                '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                '</div>'
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });
        var imgKey = Object.keys(aDataUpdate);
        parent.$('body').append(overlaypanel);

        //Event updatetagfolder
        $.ajax({
            url: parent.wex.route_action.routeCommonUrl + '/updatetagfolder',
            type: 'post',
            data: {
                tagname: tagname,
                keytag: keytag,
                befortag: befortag,
                imgKey: imgKey,
            },
            headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
        })
            .done(function (data) {
                //done do
                parent.tagfolder = data.tagfolder;
                parent.$('#edittag').remove();

                var divtag = parent.$(
                    '.tagFolder[tagname="' + data.btagfolder + '"]'
                );
                var retag = parent.$(
                    '.edittag[tagname="' + data.btagfolder + '"]'
                );
                var cTag = parent.$(
                    '.delTag[tagname="' + data.btagfolder + '"]'
                );
                parent.$('.overlaypanel').remove();

                parent.$('#ediTag').remove();
                var itemTagFolder = $(
                    '<div class="tagFolder" key="' +
                        data.key +
                        '" tagName="' +
                        data.ntagfolder +
                        '"><span>' +
                        data.ntagfolder +
                        '</span></div>'
                );
                itemTagFolder.click(RVwys.imagemanager.clicksTagFolder);
                divtag.after(itemTagFolder);

                RVwys.imagemanager.initTagfolderdrop(itemTagFolder);

                var editTag = $(
                    '<li title="Rename Tag" class="edittag uk-icon uk-icon-pencil" key="' +
                        data.key +
                        '" tagName="' +
                        data.ntagfolder +
                        '" style="    cursor: pointer;float: right;    margin-top: -17px;margin-right: 25px;" ></li>'
                );
                retag.after(editTag);
                editTag.click(RVwys.imagemanager.ClicksEditTagFolder);

                var delTagFolder = $(
                    '<li title="Delete Tag" key="' +
                        data.key +
                        '" tagName="' +
                        data.ntagfolder +
                        '" class="delTag uk-icon uk-icon-close"></li>'
                );
                cTag.after(delTagFolder);
                delTagFolder.click(RVwys.imagemanager.ClicksDelTagFolder);

                divtag.remove();
                retag.remove();
                cTag.remove();

                console.pop.error({
                    text: 'Update Folder Name Success',
                    delay: 5000,
                });
            })
            .fail(function (jqXHR, textStatus) {
                console.pop.error({
                    text: 'Update Tagname Fail',
                    delay: 5000,
                });
                //fail to
                // alert("Error Update Tagname");
                parent.$('.overlaypanel').remove();
            });
    }

    RVwys.imagemanager.initImageDrag = function (obj) {
        var selected = $([]),
            offset = { top: 0, left: 0 };

        parent.$(obj).draggable({
            revert: 'invalid',
            helper: 'clone',
            cursor: 'move',
            start: function (event, ui) {
                parent.$('.ui-PanelImageManager').css('position', 'absolute');

                if ($(this).hasClass('ui-selected')) {
                    selected = parent.$('.ui-selected').each(function () {});
                    //		            console.log(selected);
                } else {
                    selected = $([]);
                    parent.$(obj).removeClass('ui-selected');
                }
                offset = $(this).offset();

                ui.helper.addClass(selected);
            },
            drag: function (event, ui) {
                var $helper = ui.helper;
                $($helper).removeClass('ui-selected');

                var cDiv = parent.$('div.ui-draggable.ui-selected');
                //			    console.log("Draggable Item :: "+cDiv.length);
                //			    console.log(cDiv);
                if (cDiv.length > 1) {
                    $($helper)
                        .html(
                            "<span class='uk-icon-image'></span> " +
                                cDiv.length +
                                ' Image'
                        )
                        .css({
                            'background-color': ' #fff',
                            heigth: '25px',
                            width: '75px',
                            border: '2px solid #616161',
                            padding: '10px',
                        });
                }
            },
        });
    };

    RVwys.imagemanager.initTagfolderdrop = function (obj) {
        var overlaypanel = $(
            '<div class="overlaypanel">' +
                '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                '</div>'
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });

        //		parent.$(".tagFolder").droppable({
        parent.$(obj).droppable({
            hoverClass: 'tagFolderhover',
            drop: function (e, ui) {
                var cDiv = parent.$('div.ui-selected');
                var tagfolder = parent.$(this).attr('tagname');
                var kImg = {};

                if (cDiv.length > 0) {
                    cDiv.each(function (k) {
                        var imageKey = $(this).find('.insert').attr('imagekey');
                        var image = $(this).find('img');

                        parent.myimages[imageKey]['tagFolder'] = tagfolder;

                        $(this).fadeOut('slow');

                        if ($(this).hasClass('ui-selected')) {
                            $(this).removeClass('ui-selected');
                        }

                        kImg[k] = imageKey;
                    });

                    var imgKey = Object.values(kImg);
                    console.log('addtagMulti:: ' + imgKey);
                    parent.$('body').append(overlaypanel);

                    //addtagImageMulti
                    $.ajax({
                        url:
                            parent.wex.route_action.routeCommonUrl +
                            '/addtagImageMulti',
                        type: 'post',
                        data: {
                            imageKey: imgKey,
                            tagfolder: tagfolder,
                        },
                        headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
                    })
                        .done(function (data) {
                            //success do
                            parent.$('.overlaypanel').remove();
                        })
                        .fail(function (jqXHR, textStatus) {
                            //fail do
                            alert('Error : ' + textStatus);
                            parent.$('.overlaypanel').remove();
                        });
                } else {
                    var imageKey = $(ui.draggable)
                        .find('.insert')
                        .attr('imagekey');
                    var image = $(ui.draggable).find('img');
                    var tagfolders = image.attr('tagfolder');
                    var tag = image.attr('tag');
                    var solution = image.attr('solution');
                    var size = image.attr('size');
                    var date = image.attr('date');

                    $(ui.draggable).fadeOut('slow');

                    parent.$('body').append(overlaypanel);

                    //addtagImage
                    $.ajax({
                        url:
                            parent.wex.route_action.routeCommonUrl +
                            '/addtagImage',
                        type: 'post',
                        data: {
                            imageKey: imageKey,
                            tag: tag,
                            solution: solution,
                            size: size,
                            date: date,
                            tagfolderID: tagfolder,
                        },
                        headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
                    })
                        .done(function (data) {
                            //done do
                            console.log('imageKey ->' + imageKey);
                            console.log('Before :: ' + parent.myimages);
                            console.log('tagfolder -> ' + tagfolder);
                            parent.myimages[imageKey]['tagFolder'] = tagfolder;
                            console.log('After :: ' + parent.myimages);
                            console.log(parent.myimages);

                            parent.$('.overlaypanel').remove();
                        })
                        .fail(function (jqXHR, textStatus) {
                            //todo
                            alert('Error : ' + textStatus);
                        });
                }
            },
        });
    };

    RVwys.imagemanager.findMyImageBytagFolder = function (tagName) {
        var tagLike = new RegExp(tagName, 'img');
        var myImageList = '';
        var isReturn = false;
        var aDataFined = {};
        if (tagName != 'All Images') {
            clearTimeout(window.myImageListProcess);
            $.each(parent.myimages, function (k, v) {
                if (v.tagFolder.search(tagLike) != -1) {
                    aDataFined[k] = v;
                }
            });
            console.log('aDataFined -->');
            console.log(aDataFined);

            myImageList = aDataFined;

            isReturn = aDataFined;
        } else {
            myImageList = parent.myimages;
        }

        var maxItem = Object.keys(myImageList).length;
        window.myImageListProcess = setTimeout(function () {
            RVwys.imagemanager.myImageList(
                maxItem - 1,
                0,
                Object.keys(myImageList)
            );
        }, 50);

        return isReturn;
    };

    function addMyImageTagfolder(tagJSON) {
        var overlaypanel = $(
            '<div class="overlaypanel">' +
                '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                '</div>'
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });

        parent.$('body').append(overlaypanel);

        $.ajax({
            url: parent.wex.route_action.routeCommonUrl + '/addtagfolder',
            type: 'post',
            data: { tagname: tagJSON },
            headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
        })
            .done(function (data) {
                //console.log(data)
                var tagname = data.tagname;
                parent.tagfolder = data.tagfolder;
                console.log('add Folder::' + parent.tagfolder);
                parent.$('.overlaypanel').remove();

                var itemTagFolder = $(
                    '<div class="tagFolder" key="' +
                        data.key +
                        '" tagName="' +
                        tagname +
                        '"><span>' +
                        tagname +
                        '</span></div>'
                );
                itemTagFolder.click(RVwys.imagemanager.clicksTagFolder);
                parent.$('.listMyfolder').append(itemTagFolder);

                RVwys.imagemanager.initTagfolderdrop(itemTagFolder);

                var editTag = $(
                    '<li title="Rename Tag" class="edittag uk-icon uk-icon-pencil" key="' +
                        data.key +
                        '" tagName="' +
                        tagname +
                        '" style="    cursor: pointer;float: right;    margin-top: -17px;margin-right: 25px;" ></li>'
                );
                parent.$('.listMyfolder').append(editTag);
                editTag.click(RVwys.imagemanager.ClicksEditTagFolder);

                var delTagFolder = $(
                    '<li title="Delete Tag" key="' +
                        data.key +
                        '" tagName="' +
                        tagname +
                        '" class="delTag uk-icon uk-icon-close"></li>'
                );
                parent.$('.listMyfolder').append(delTagFolder);
                delTagFolder.click(RVwys.imagemanager.ClicksDelTagFolder);

                parent.$('#daddtag').remove();
            })
            .fail(function (jqXHR, textStatus) {
                parent.$('.overlaypanel').remove();
            });
    }

    RVwys.imagemanager.myImageList = function (iIndex, cLimit, data) {
        console.log('RVwys.imagemanager.myImageList');
        console.log('iIndex: ', iIndex);
        //console.log('data: ', data);

        var imageKey = data[iIndex];
        console.log('imageName-> ' + imageKey + ' array key' + iIndex);
        if (imageKey == undefined) {
            return false;
        }
        if (cLimit > window.displayLimitImage) {
            window.cacheImageMore = data;
            var oMore = $(
                '<div class="myMore checkleft"><button now = "' +
                    iIndex +
                    '" class="btn-input padlt">More</button></div>'
            );
            oMore.find('button').click(function (e) {
                RVwys.imagemanager.myImageList(
                    $(this).attr('now'),
                    0,
                    window.cacheImageMore
                );
                $(this).remove();
            });
            parent.$('.workspace').append(oMore);

            return false;
        }
        if (iIndex >= 0) {
            var imageName = parent.storeimages[imageKey]['name'];
            var urlImage =
                parent.wex.url.STORAGE_URL +
                '/' +
                parent.storeimages[imageKey]['path'].replace(/\-dot\-/gim, '.');
            var urlImageThumbnails =
                parent.wex.url.STORAGE_URL +
                '/' +
                parent.storeimages[imageKey]['path'].replace(/\-dot\-/gim, '.');

            var reName = urlImageThumbnails.split('/');
            reName[reName.length - 1] =
                'wpThumbnails/' + reName[reName.length - 1];
            urlImageThumbnails = reName.join('/');
            //alert(urlImageThumbnails)
            //console.log('imageName->'+urlImage);
            var imageItemHTML = parent.$('#designMyImageItem').html();
            var oImageItem = $(imageItemHTML);

            //
            //			alert(imageItemHTML)
            var oImageItem = $(imageItemHTML);
            oImageItem
                .find('.insert')
                .attr({ data: urlImage, imagekey: imageKey });
            oImageItem
                .find('.remove')
                .attr({ imagename: imageName, imagekey: imageKey });
            var attr = { src: urlImageThumbnails, id: 'my' + imageName };
            Object.assign(attr, parent.myimages[imageKey]);
            oImageItem.find('.imageItems').attr(attr);
            oImageItem = RVwys.imagemanager.eventMyImage(oImageItem);

            if (oImageItem.find('[id*=mylogo-mobile]').length > 0) {
                oImageItem
                    .find('[id*=mylogo-mobile]')
                    .parent()
                    .addClass('hide-mylogo-mobile');
            }

            parent
                .$('.imageBoxView-myimage')
                .find('.workspace')
                .append(oImageItem);

            //				Select Image By Selectable
            parent.$('.imageBoxView-myimage').selectable();
            RVwys.imagemanager.initImageDrag(oImageItem);

            iIndex--;
            cLimit++;
            window.myImageListProcess = setTimeout(function () {
                RVwys.imagemanager.myImageList(iIndex, cLimit, data);
            }, 10);
        }
    };

    $(document).bind('editorReady', function () {});

    RVwys.designViewAddEvent('mousedown', function (e) {
        var curRange = $(e.target);
        //		alert(parent.dynamicShow);
        var isTagImg =
            curRange.get(0).tagName == 'IMG' ||
            curRange.hasClass('borderResize');
        if (parent.$('.imageLib').is(':visible')) {
            if (!isTagImg) {
                parent.$('.wys-dynamic').toggle(parent.dynamicShow);
                parent.$('.wys-rowTwo').toggle(!parent.dynamicShow);
                parent.$('.imageLib').hide();
            }
        } else {
            parent.curImage = false;
            parent.focusImage = false;

            if (!curRange.hasClass('imgEditor')) {
                parent.$('.wys-dynamic').toggle(parent.dynamicShow);
                parent.$('.wys-rowTwo').toggle(!parent.dynamicShow);
            }
            $('.image-editor-tool,.image-editor-overlay').hide();
            $('#imedit-reEdit,#imedit-rechoose,#imedit-edit').hide();
        }
    });
})(jQuery);
